import { useQuery } from '@tanstack/react-query';

import { fetchShipmentLSPStationCodeList } from '../../data-provider/select-options';
import type { ShipmentLSPStationCodeListRequestParams } from '../../data-provider/select-options/lsp-station-code-list/api';

export const useGetShipmentLSPStationCodeList = (params: ShipmentLSPStationCodeListRequestParams) => {
  return useQuery({
    enabled: Boolean(params?.customerKey),
    queryFn: () => fetchShipmentLSPStationCodeList(params),
    queryKey: ['shipment-lsp-station-code-list', params?.customerKey],
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
